import { Specs } from '@doxyme/extensions-common';
import ControlCapability from '../control';

const { AppsDockControl } = Specs;
type Constraints = Specs.AppsDockControl.Constraints;

export default class AppsDockControlCapability extends ControlCapability<Constraints> {
  static id = AppsDockControl.id;

  constructor() {
    super(AppsDockControl);
  }
}
